<template>
<div id="user-home">
  <VtoolBarHome></VtoolBarHome>
  <HelloWorld />
</div>
</template>

<script>
  import HelloWorld from '../components/HelloWorld';
  import VtoolBarHome from '../components/VtoolBarHome';

  export default {
    components: {
      HelloWorld,
      VtoolBarHome,
    }
  }
</script>
